import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import CaseStudy from '@src/components/DisposalPage/CaseStudy'
import FAQ from '@src/components/DisposalPage/FAQ'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import officeCleanout from '../../json/commercial-office-cleanout-data.json'

const officeCleanoutServiceData = {
  name: 'Commercial and Office Cleanout Services',
  description:
    'Nationwide commercial cleanout service for offices, retail units, warehouses, and restaurants — desks, cubicles, filing cabinets, and equipment cleared for lease expirations, renovations, and closures, with a diversion report on completion.',
  serviceType: 'Commercial Cleanout',
  url: 'https://getdimension.com/commercial-office-cleanout',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Office Cleanout' },
    { name: 'Office Furniture and Cubicle Removal' },
    { name: 'Retail and Restaurant Cleanout' },
    { name: 'Warehouse Cleanout' },
    { name: 'Lease Expiration and Closure Clear-Out' },
  ],
}

const officeCleanoutFAQData = {
  questions: officeCleanout.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function CommercialOfficeCleanout() {
  return (
    <>
      <Head>
        <title>Office &amp; Commercial Cleanout Services | Dimension</title>
        <meta
          name="description"
          content="Commercial and office cleanout services nationwide. Desks, cubicles, filing cabinets, and equipment cleared for lease expirations, renovations, and closures."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/commercial-office-cleanout" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={officeCleanoutServiceData} />
        <SchemaMarkup type="FAQPage" data={officeCleanoutFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={officeCleanout.pitch.heading}
          material={officeCleanout.pitch.material}
          pitchText={officeCleanout.pitch.pitchText}
          ctaLink={officeCleanout.pitch.ctaLink}
          ctaText={officeCleanout.pitch.ctaText}
          ctaHeading={officeCleanout.pitch.ctaHeading}
          ctaSubtext={officeCleanout.pitch.ctaSubtext}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...officeCleanout.solutions} />
        <FeatureList {...officeCleanout.benefits} />
        <CaseStudy {...officeCleanout.caseStudy} />
        <Approach {...officeCleanout.approach} />
        <FAQ {...officeCleanout.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Property Cleanouts',
              href: '/property-cleanouts',
              description:
                'The hub for every kind of cleanout we run — homes, offices, estates, garages, and basements.',
            },
            {
              label: 'Furniture Removal',
              href: '/furniture-removal',
              description:
                'Desks, chairs, conference tables, and cabinets when furniture is the whole job rather than part of it.',
            },
            {
              label: 'E-Waste Recycling',
              href: '/ewaste',
              description:
                'Computers, monitors, printers, and cabling routed into certified electronics recycling.',
            },
            {
              label: 'Certified Destruction',
              href: '/certified-destruction',
              description:
                'Documented chain of custody for hard drives, servers, and confidential records.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default CommercialOfficeCleanout
